import React from 'react';
import { connect } from 'react-redux';
import Servicios from './servicios.cmpt';
import Resultados from './resultados.cmpt';

const mapState = (state) => {
    return {
        paso: state.directorio.paso,
        servicio: state.directorio.servicios
    };
}

const mapDispatch = (dispatch) => {
    return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},        
        pasoAnterior: (_paso) => {
            dispatch({ "type": "DIRECTORIO_PASO_ANTERIOR" });
        },
        resetServicio: () => {
            dispatch({ "type": "DIRECTORIO_SERVICIOS_FORM", "servicios": 0 });
        }
    }
}

class Flujo extends React.Component {

    componentWillMount(){
        this.props.resetServicio();
    }
    
    atras = () => {
        this.props.pasoAnterior();
        $("#contCMS .map-movil").hide();
        if($(".map-movil-fix").hasClass("busqueda-modulo")){
            $(".map-movil-fix").removeClass("busqueda-modulo");
        }

    }

    medicoMovil = () => {
        console.log("AGREGA MEDICO MOVIL");
        //$(".map-movil-fix").hasClass("medicos-movil")
        if($(".map-movil-fix").hasClass("hospitales-modulo")){
            $(".map-movil-fix").removeClass("hospitales-modulo");
            $(".map-movil-fix").addClass("medicos-modulo");
        }else{
            $(".map-movil-fix").addClass("medicos-modulo");
        }

        return true;
    }

    hospitalMovil = () => {
        console.log("AGREGA HOSPITAL MOVIL");
        if($(".map-movil-fix").hasClass("medicos-modulo")){
            $(".map-movil-fix").removeClass("medicos-modulo");
            $(".map-movil-fix").addClass("hospitales-modulo");
        }else{
            $(".map-movil-fix").addClass("hospitales-modulo");
        }

        return true;
    }

    resultadosMovil = () => {
        console.log("AGREGA RESULTADOS MOVIL");
        if($(".map-movil-fix").hasClass("medicos-modulo")){
            $(".map-movil-fix").removeClass("medicos-modulo");
            $(".map-movil-fix").addClass("busqueda-modulo");

        }
        if($(".map-movil-fix").hasClass("hospitales-modulo")){
            $(".map-movil-fix").removeClass("hospitales-modulo");
            $(".map-movil-fix").addClass("busqueda-modulo");
        }
        
        else{
            $(".map-movil-fix").addClass("busqueda-modulo");
        }

        return true;
    }

    eliminaClases = () => {
        if($(".map-movil-fix").hasClass("medicos-modulo")){
            $(".map-movil-fix").removeClass("medicos-modulo");
        }

        if($(".map-movil-fix").hasClass("hospitales-modulo")){
            $(".map-movil-fix").removeClass("hospitales-modulo");
        }

        if($(".map-movil-fix").hasClass("busqueda-modulo")){
            $(".map-movil-fix").removeClass("busqueda-modulo");
        }

        return true;
    }

    render() {
        return (
            <div>
                { this.props.paso != 0 && 
                    <div className="row directorio-back-arrow">
                        <div className="col-xs-12">
                            <a onClick={this.atras} className="pull-left">
                                <img src={ require("../img/arrow-back.svg") } alt="atras" />
                            </a>
                        </div>
                    </div>
                }
                { this.props.paso == 0 && this.eliminaClases() &&
                    <Servicios />
                }
                { this.props.paso == 1 && this.eliminaClases() &&
                    <Servicios />
                }
                { this.props.paso == 2 && this.resultadosMovil() &&
                    <Resultados />
                }
            </div>
        )
    }
}

export default connect(mapState, mapDispatch)(Flujo);



// WEBPACK FOOTER //
// ./src/directorio/flujo.cmpt.js